<template>
  <transition name="fade">
    <div class="preloader__wrapper">
      <div v-show="loading" class="preloader__img">
        <svg xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             style="margin: auto; background: none; display: block; shape-rendering: auto;"
             width="100%"
             height="100%"
             viewBox="25 25 50 50"
             preserveAspectRatio="xMidYMid"
        >
          <circle cx="50" cy="50" fill="none" :stroke="color" stroke-width="10" r="18" stroke-dasharray="66 24"></circle>
        </svg>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "Preloader",
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
      color: {
        type: String,
        default: '#4c8aa3',
      },
    }
  }
</script>

<style lang="scss" scoped>
  $iconSize: 24px;

  .preloader {
    &__wrapper {
      text-align: center;
      height: $iconSize;
    }

    &__img {
      margin: auto;
      width: $iconSize;
      height: $iconSize;
      animation: spin 1s linear infinite;
    }
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
